(() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b)) {
        if (__propIsEnum.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      }
    return a;
  };

  // resources/global/scroll-util.js
  if (!customElements.get("scroll-tracker")) {
    customElements.define(
      "scroll-tracker",
      class ScrollTracker extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this._updateScroll = this._updateScroll.bind(this);
          this.callbacks = [];
          this.lastTs = 0;
          this.lastScrollY = 0;
          this.rafRef = requestAnimationFrame(this._updateScroll);
          window.scrollTracker = this;
        }
        addListener(cb) {
          this.callbacks.push(cb);
        }
        removeListener(cb) {
          this.callbacks.splice(
            this.callbacks.findIndex((icb) => cb === icb),
            1
          );
        }
        trackElementInView(element, callback, options = { effectInViewOnly: true, inViewMargin: [0, 0, 0, 0] }) {
          let lastInView = false;
          const updateElementRect = (scrollData) => {
            const {
              effectInViewOnly,
              // eslint-disable-next-line no-unused-vars
              inViewMargin: [mTop, mRight, mBottom, mLeft] = [0, 0, 0, 0]
            } = options;
            if (!element) return;
            const data = element.getBoundingClientRect();
            data.middle = data.top + data.height / 2;
            data.viewMiddle = data.middle - window.innerHeight / 2;
            data.viewMiddleTop = data.top - window.innerHeight / 2;
            data.inView = data.top + data.height + mTop > 0 && data.top + mBottom < window.innerHeight;
            data.isLeaving = lastInView && !data.inView;
            data.isEntering = !lastInView && data.inView;
            if (!effectInViewOnly || effectInViewOnly && data.inView || data.isLeaving) callback(data, scrollData);
            lastInView = data.inView;
          };
          this.trackScroll(updateElementRect);
        }
        trackScroll(callback) {
          this.addListener(callback);
        }
        _updateScroll(time) {
          const elapsedMs = time - this.lastTs;
          if (elapsedMs >= 16) {
            const curScrollY = window.scrollY;
            const dScroll = this.lastScrollY - curScrollY;
            const trackingData = {
              dScroll,
              scrollY,
              lastScrollY: this.lastScrollY,
              elapsedMs,
              time
            };
            this.callbacks.forEach((cb) => cb(trackingData));
            this.lastScrollY = curScrollY;
            this.lastTs = time;
          }
          this.rafRef = requestAnimationFrame(this._updateScroll);
        }
      }
    );
  }

  // resources/global/sticky-highlighter.js
  var StickyHighlighter = class {
    constructor(stickyElement, items, options = {}) {
      this.stickyElement = stickyElement;
      this.items = Array.from(items);
      this.options = __spreadValues({
        offset: 0,
        activeClass: "highlighted",
        debounceTime: 50
      }, options);
      this.currentActiveIndex = -1;
      this.isScrollingUp = false;
      this.lastScrollY = window.scrollY;
      this.intersectionStates = /* @__PURE__ */ new Map();
      this.debounceTimeout = null;
      this.init();
    }
    init() {
      this.setupScrollDirection();
      this.createObserver();
      this.startObserving();
    }
    setupScrollDirection() {
      let ticking = false;
      window.addEventListener("scroll", () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            const currentScrollY = window.scrollY;
            this.isScrollingUp = currentScrollY < this.lastScrollY;
            this.lastScrollY = currentScrollY;
            ticking = false;
            this.evaluateActiveItem();
          });
          ticking = true;
        }
      });
    }
    createObserver() {
      this.observer = new IntersectionObserver((entries) => this.handleIntersections(entries), {
        rootMargin: this.calculateRootMargin(),
        threshold: [0, 0.1, 0.5, 1]
      });
    }
    calculateRootMargin() {
      const stickyRect = this.stickyElement.getBoundingClientRect();
      const stickyCenter = stickyRect.top + stickyRect.height / 2;
      const tolerance = 20;
      const topMargin = -(stickyCenter - tolerance);
      const bottomMargin = -(window.innerHeight - stickyCenter - tolerance);
      return `${topMargin}px 0px ${bottomMargin}px 0px`;
    }
    handleIntersections(entries) {
      entries.forEach((entry) => {
        const itemIndex = this.items.indexOf(entry.target);
        if (itemIndex !== -1) {
          this.intersectionStates.set(itemIndex, {
            isIntersecting: entry.isIntersecting,
            intersectionRatio: entry.intersectionRatio,
            boundingRect: entry.boundingClientRect
          });
        }
      });
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.evaluateActiveItem();
      }, this.options.debounceTime);
    }
    evaluateActiveItem() {
      const stickyRect = this.stickyElement.getBoundingClientRect();
      const stickyCenter = stickyRect.top + stickyRect.height / 2;
      const firstItemRect = this.items[0].getBoundingClientRect();
      const isBeforeFirstItem = stickyCenter < firstItemRect.top;
      if (isBeforeFirstItem) {
        if (this.currentActiveIndex >= 0) {
          this.setActiveItem(-1);
        }
        return;
      }
      let bestCandidate = -1;
      let bestDistance = Infinity;
      this.items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const state = this.intersectionStates.get(index);
        if (rect.bottom > 0 && rect.top < window.innerHeight) {
          const itemCenter = rect.top + rect.height / 2;
          const distance = Math.abs(itemCenter - stickyCenter);
          const isInActivationZone = state && state.isIntersecting;
          const priority = isInActivationZone ? distance : distance + 1e3;
          if (priority < bestDistance) {
            bestDistance = priority;
            bestCandidate = index;
          }
        }
      });
      if (bestCandidate !== this.currentActiveIndex) {
        if (bestCandidate >= 0) {
          const candidateRect = this.items[bestCandidate].getBoundingClientRect();
          const candidateCenter = candidateRect.top + candidateRect.height / 2;
          const distanceToSticky = Math.abs(candidateCenter - stickyCenter);
          if (distanceToSticky < window.innerHeight / 3) {
            this.setActiveItem(bestCandidate);
          }
        } else if (this.currentActiveIndex >= 0) {
          this.clearActiveItem();
        }
      }
    }
    setActiveItem(index) {
      if (this.currentActiveIndex === index) {
        return;
      }
      this.clearActiveItem();
      this.currentActiveIndex = index;
      if (index >= 0) {
        this.items[index].classList.add(this.options.activeClass);
      }
      if (this.options.onActiveChange) {
        this.options.onActiveChange(index, index >= 0 ? this.items[index] : null);
      }
    }
    clearActiveItem() {
      if (this.currentActiveIndex >= 0) {
        this.items[this.currentActiveIndex].classList.remove(this.options.activeClass);
      }
    }
    startObserving() {
      this.items.forEach((item) => {
        this.observer.observe(item);
      });
    }
    updateDebugInfo() {
      const debugElement = document.getElementById("debugInfo");
      if (debugElement) {
        const activeItem = this.currentActiveIndex >= 0 ? `Item ${this.currentActiveIndex + 1}` : "None";
        const direction = this.isScrollingUp ? "\u2191" : "\u2193";
        debugElement.textContent = `Active item: ${activeItem} ${direction}`;
      }
    }
    destroy() {
      if (this.observer) {
        this.observer.disconnect();
      }
      this.intersectionStates.clear();
      clearTimeout(this.debounceTimeout);
    }
    // Method to update the configuration if the sticky element's position changes
    recalculate() {
      this.destroy();
      this.createObserver();
      this.startObserving();
    }
  };
  window.StickyHighlighter = StickyHighlighter;

  // resources/global/animation.js
  if (!customElements.get("ani-scroll-view")) {
    customElements.define(
      "ani-scroll-view",
      class AniScrollView extends HTMLElement {
        constructor() {
          super();
          this._trackInView = this._trackInView.bind(this);
        }
        connectedCallback() {
          this.classList.add("ani");
          this._triggered = false;
          this._autoStagger();
          window.scrollTracker.trackElementInView(this, this._trackInView);
        }
        _autoStagger() {
          this.querySelectorAll(".ani").forEach((el, i) => {
            if (i > 0) el.style.setProperty("--ani-delay", `${i * 100}ms`);
          });
        }
        _trackInView(data) {
          const isInView = data.viewMiddle <= window.innerHeight / 3;
          if (!this._triggered && isInView) {
            this.classList.add("ani--play");
            this._triggered = true;
          }
        }
      }
    );
  }

  // resources/global/site-header.js
  if (!customElements.get("site-header")) {
    customElements.define(
      "site-header",
      class SiteHeader extends HTMLElement {
        constructor() {
          super();
          this._handleScroll = this._handleScroll.bind(this);
        }
        connectedCallback() {
          this.navIcon = this.querySelector(".nav-icon");
          this.nav = this.querySelector(".site-header__menu");
          this.header = this.querySelector(".site-header");
          this.announcementBar = this.querySelector(".site-header__announcement-bar");
          window.scrollTracker.trackScroll(this._handleScroll);
          if (this.navIcon) {
            this._listen();
          }
          this._isInitialized = false;
          this._isVisible = true;
          this._isAtTop = document.scrollTop === 0;
          const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
              const height = entry.borderBoxSize[0].blockSize;
              const isHeader = entry.target === this.header;
              const elName = isHeader ? "header" : "announcement-bar";
              document.documentElement.style.setProperty(`--${elName}-height`, `${height}px`);
              if (isHeader) document.body.classList.add("site--header-ready");
            });
          });
          resizeObserver.observe(this.header);
          if (this.announcementBar) resizeObserver.observe(this.announcementBar);
          setTimeout(() => {
            this._toggleIsAtTop(this._isAtTop);
            this._toggleIsVisible(true);
            if (this.header.classList.contains("site-header--has-announcement")) {
              document.body.classList.add("site--has-announcement");
            }
            this._isInitialized = true;
          });
        }
        _listen() {
          this.navIcon.addEventListener("click", () => {
            document.body.classList.toggle("nav-open");
            this.navIcon.classList.toggle("close");
            this.nav.classList.toggle("open");
            this.header.classList.toggle("open");
          });
          this.nav.querySelectorAll(".list-menu__item-caret").forEach((caretEl) => {
            caretEl.addEventListener("click", () => this._submenuToggle(caretEl));
            if (caretEl.previousElementSibling.tagName === "SPAN") {
              caretEl.previousElementSibling.addEventListener("click", () => this._submenuToggle(caretEl));
            }
            caretEl.parentElement.addEventListener("mouseenter", () => this._submenuToggle(caretEl, "open"));
            caretEl.parentElement.addEventListener("mouseleave", () => this._submenuToggle(caretEl, "close"));
          });
        }
        _toggleIsVisible(willBeVisible) {
          this._isVisible = willBeVisible;
          this.header.classList.toggle("site-header--hidden", !willBeVisible);
        }
        _toggleIsAtTop(willBeAtTop) {
          this._isAtTop = willBeAtTop;
          this.header.classList.toggle("site-header--scrolled", !willBeAtTop);
        }
        _handleScroll(scrollData) {
          if (!this._isInitialized) return;
          const { dScroll, scrollY: scrollY2 } = scrollData;
          if (dScroll < 0 && this._isVisible) {
            this._toggleIsVisible(false);
          } else if (dScroll > 0 && !this._isVisible) {
            this._toggleIsVisible(true);
          }
          if (scrollY2 > 0 && this._isAtTop) {
            this._toggleIsAtTop(false);
          } else if (scrollY2 === 0 && !this._isAtTop) {
            this._toggleIsAtTop(true);
          }
        }
        _submenuToggle(caretEl, force, closeOther = true) {
          if (closeOther) {
            const openSubMenuCarets = this.nav.querySelectorAll('[aria-expanded="true"]');
            openSubMenuCarets.forEach(
              (otherCaretEl) => otherCaretEl !== caretEl && this._submenuToggle(otherCaretEl, "close", false)
            );
          }
          const submenuEl = document.getElementById(caretEl.getAttribute("aria-controls"));
          let isNextExpanded = force === "open" || !(caretEl.ariaExpanded === "true");
          caretEl.setAttribute("aria-expanded", isNextExpanded ? "true" : "false");
          submenuEl.querySelectorAll("a").forEach((focusableElement) => {
            if (isNextExpanded) focusableElement.removeAttribute("tabindex");
            else focusableElement.tabIndex = "-1";
          });
          submenuEl.style.setProperty("--mobile-menu-height", `${isNextExpanded ? submenuEl.scrollHeight : 0}px`);
        }
      }
    );
  }

  // resources/global/chat.js
  document.querySelectorAll('[href="#chat"]').forEach((chatLink) => {
    chatLink.addEventListener("click", (event) => {
      event.preventDefault();
      GorgiasChat == null ? void 0 : GorgiasChat.open();
    });
  });
})();
